import * as React from 'react'
import { useMemo } from 'react'

import {
  selectAllSalesFunnels,
  useGetSalesFunnelListOnMount,
} from '@user/store/salesFunnel'
import { useAppSelector } from '@user/store/hooks'
import type { IOption, IProviderProps } from '@user/components/Filters'

export function SalesFunnelProvider(props: IProviderProps) {
  const { render } = props

  const status = useGetSalesFunnelListOnMount()

  const loading = status === 'pending'

  const funnels = useAppSelector(selectAllSalesFunnels)

  const options = useMemo(
    () => funnels.map<IOption>((f) => ({ value: f.id, label: f.name })),
    [funnels],
  )

  return <>{render(options, loading)}</>
}
